<boels-order-entry-item
  [orderEntry]="orderEntry()"
  [variant]="variant()"
  type="main"
  [autoFocusTarget]="autoFocusTarget()"
  (deleteOrderEntry)="deleteOrderEntry.emit($event)"
  (entryEditRequested)="entryEditRequested.emit($event)"
  (mainQuantityChanged)="mainQuantityChanged.emit($event)"
></boels-order-entry-item>

@if (accessories() && accessories()!.length > 0) {
  <boels-order-entry-accessories-group
    [@accessoriesListEnterAnimation]
    (@accessoriesListEnterAnimation.done)="accessoriesListAnimationDone()"
    [collapsible]="variant() === 'readonly'"
    [accessoriesCount]="accessories()!.length"
  >
    @for (accessory of accessories(); track $index) {
      <boels-order-entry-item
        [orderEntry]="accessory"
        [variant]="variant()"
        [autoFocusTarget]="autoFocusTargetWhenAnimationDone()"
        type="accessory"
        (entryEditRequested)="entryEditRequested.emit($event)"
      ></boels-order-entry-item>
    }
  </boels-order-entry-accessories-group>
}
